import type { SubitemScript } from './types';

/**
 * @example
 * formatSubitemKindLabel("Subitem::Card")  // => "Card"
 * formatSubitemKindLabel("Subitem::QuestionField")  // => "Question Field"
 * formatSubitemKindLabel("Subitem::Background")  // => "Background"
 * formatSubitemKindLabel(null)  // => "Subitem"
 */

export const formatSubitemKindLabel = (kind?: string | null): string => {
  const raw = (kind ?? '').trim();
  const last = raw.split('::').pop() || raw || 'Subitem';
  const spaced = last
    .replace(/_/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim();
  return spaced || 'Subitem';
};

export const subitemFieldLabel = (
  kind: string | null | undefined,
  field: string
) => `${formatSubitemKindLabel(kind)} ${field}`.trim();

export const flattenSubitems = (
  items: SubitemScript[] | undefined | null
): SubitemScript[] => {
  const result: SubitemScript[] = [];
  const visit = (subitems: SubitemScript[] | undefined | null) => {
    if (!Array.isArray(subitems)) return;
    for (const subitem of subitems) {
      result.push(subitem);
      if (Array.isArray(subitem.subitems) && subitem.subitems.length > 0) {
        visit(subitem.subitems);
      }
    }
  };
  visit(items);
  return result;
};
